/**
 * AI面试状态（本场面试的状态）
 */
export var INTERVIEW_STATUS;
(function (INTERVIEW_STATUS) {
    INTERVIEW_STATUS[INTERVIEW_STATUS["NO_ANSWER"] = 1] = "NO_ANSWER";
    INTERVIEW_STATUS[INTERVIEW_STATUS["IN_CALCULATION"] = 2] = "IN_CALCULATION";
    INTERVIEW_STATUS[INTERVIEW_STATUS["COMPLETED"] = 3] = "COMPLETED";
    INTERVIEW_STATUS[INTERVIEW_STATUS["FAILED"] = 4] = "FAILED";
    INTERVIEW_STATUS[INTERVIEW_STATUS["CHEAT"] = 5] = "CHEAT";
})(INTERVIEW_STATUS || (INTERVIEW_STATUS = {}));
/**
 * 题目面试状态（当场面试中单道题目的状态）
 */
export var INTERVIEW_STEP_STATUS;
(function (INTERVIEW_STEP_STATUS) {
    INTERVIEW_STEP_STATUS[INTERVIEW_STEP_STATUS["STEP_NO_ANSWER"] = 1] = "STEP_NO_ANSWER";
    INTERVIEW_STEP_STATUS[INTERVIEW_STEP_STATUS["STEP_IN_CALCULATION"] = 2] = "STEP_IN_CALCULATION";
    INTERVIEW_STEP_STATUS[INTERVIEW_STEP_STATUS["STEP_COMPLETED"] = 3] = "STEP_COMPLETED";
    INTERVIEW_STEP_STATUS[INTERVIEW_STEP_STATUS["STEP_FAILED"] = 4] = "STEP_FAILED";
})(INTERVIEW_STEP_STATUS || (INTERVIEW_STEP_STATUS = {}));
/**
 * 题目完成状态
 */
export var COMPLETED_STATUS;
(function (COMPLETED_STATUS) {
    COMPLETED_STATUS[COMPLETED_STATUS["NOT_START"] = 1] = "NOT_START";
    COMPLETED_STATUS[COMPLETED_STATUS["NOT_COMPLETED"] = 2] = "NOT_COMPLETED";
    COMPLETED_STATUS[COMPLETED_STATUS["COMPLETED"] = 3] = "COMPLETED";
})(COMPLETED_STATUS || (COMPLETED_STATUS = {}));
export var BackgroundImage = {
    pro: 'https://webcdn.fbmms.cn/assets/DPXE/Oj-k12zdt9HuOrcEECDsm',
    standard: 'https://webcdn.fbmms.cn/assets/S3uM/nAU25qJa6bVmZVHpcb11G',
};
export var Colors = {
    pro: '#86350F',
    standard: '#4caf50',
};
export var SwitchTitle = {
    standard: '升级为专业版',
    pro: '切换为标准版',
};
